<template>
  <div>
    <el-dialog title="新增项目经历" :close-on-click-modal="false" :visible.sync="display" size="small" @close='closeDialog'>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="起始时间">
          <el-col :span="11">
            <el-form-item label="" prop="start_date">
              <el-date-picker v-model="form.start_date" format="yyyy/MM" type="month" placeholder="选择日期"
                value-format="yyyy/MM" style="width:100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="line">-</el-col>
          <el-col :span="11">
            <el-form-item label="" prop="end_date">
              <el-date-picker v-model="form.end_date" type="month" placeholder="选择日期" value-format="yyyy/MM"
                style="width:100%;" ref="endDate" :picker-options="pickerOptions" :format="dateFormat"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="项目名称" prop="project_name">
          <el-input v-model="form.project_name"></el-input>
        </el-form-item>
        <el-form-item label="所属公司">
          <el-input v-model="form.company"></el-input>
        </el-form-item>
        <el-form-item label="项目描述">
          <el-input v-model="form.description" type="textarea" :autosize="{ minRows: 3, maxRows: 5}"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      ResumeID: {
        type: Number,
        default: 0
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        form: {
          exp_id: 0,
          resume_id: 0,
          start_date: '',
          end_date: '',
          project_name: '',
          company: '',
          description: ''
        },
        display: false,
        rules: {
          start_date: [{
            required: true,
            message: '请选择开始日期',
            trigger: 'change'
          }],
          end_date: [{
            required: true,
            message: '请选择结束日期',
            trigger: 'change'
          }],
          project_name: [{
            required: true,
            message: '请输入项目名称',
            trigger: 'change'
          }],
        },
        pickerOptions: {
          shortcuts: [{
            text: '至今',
            onClick(picker) {
              const date = new Date('1900-01');
              picker.$emit('pick', date);
            }
          },
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }
          ]
        }
      };
    },
    watch: {
      ResumeID: function (value) {
        this.form.resume_id = value;
      },
      visible: function (value) {
        this.display = value;
        if (this.display) {
          this.form.start_date = '';
          this.form.end_date = '';
          this.form.project_name = '';
          this.form.company = '';
          this.form.description = '';
          if (this.$refs.form) {
            this.$refs.form.clearValidate();
          }
        }
      },
    },
    mounted() {

    },
    computed: {
      dateFormat() {
        if (new Date(this.form.end_date).getFullYear() == 1900) {
          return '至今';
        }
        return 'yyyy/MM';
      },
    },
    methods: {
      cancel() {
        this.display = false;
      },
      confirm() {
        this.$refs['form'].validate((valid) => {
          if (!valid) return false;
          this.display = false;
          this.form.resume_id = this.ResumeID;
          this.$emit('change', this.form);
        });
      },
      closeDialog() {
        this.$emit('visibleChange', false);
      },
    }
  };

</script>

<style lang="scss" scoped>
  .line {
    text-align: center;
  }

</style>
